import { render, staticRenderFns } from "./HeaderLanguageToggler.vue?vue&type=template&id=8f0adb4e&"
import script from "./HeaderLanguageToggler.vue?vue&type=script&lang=js&"
export * from "./HeaderLanguageToggler.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLanguageToggler.vue?vue&type=style&index=0&id=8f0adb4e&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f0adb4e')) {
      api.createRecord('8f0adb4e', component.options)
    } else {
      api.reload('8f0adb4e', component.options)
    }
    module.hot.accept("./HeaderLanguageToggler.vue?vue&type=template&id=8f0adb4e&", function () {
      api.rerender('8f0adb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderLanguageToggler.vue"
export default component.exports